"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const gatsby_1 = require("gatsby");
const atoms_1 = require("@components/atoms");
const Input_1 = require("@components/atoms/Input");
const AccountInHeader_1 = require("@components/organisms/AccountInHeader");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils");
const _api_1 = __importDefault(require("@api"));
const _store_1 = __importDefault(require("@store")); // Component
var AccountRegisterForm = function AccountRegisterForm() {
    var _useGlobal = _store_1.default(function (state) {
        return state.panel;
    }, function (actions) {
        return actions.setPanel;
    }), setPanel = _useGlobal[1];
    var _useGlobal2 = _store_1.default(function (state) {
        return state.notification;
    }, function (actions) {
        return actions.setNotification;
    }), setNotification = _useGlobal2[1];
    var _useLocalStorage = _utils_1.useLocalStorage('newUserTier', ''), tier = _useLocalStorage[0];
    var _useGlobal3 = _store_1.default(function (state) {
        return state.regBundle;
    }, function (actions) {
        return actions.setRegBundle;
    }), regBundle = _useGlobal3[0], setRegBundle = _useGlobal3[1];
    var _React$useState = react_1.default.useState(''), email = _React$useState[0], setEmail = _React$useState[1];
    var _React$useState2 = react_1.default.useState(''), firstName = _React$useState2[0], setFirstName = _React$useState2[1];
    var _React$useState3 = react_1.default.useState(''), lastName = _React$useState3[0], setLastName = _React$useState3[1];
    react_1.default.useEffect(function () {
        setEmail((regBundle === null || regBundle === void 0 ? void 0 : regBundle.email) || '');
        setFirstName((regBundle === null || regBundle === void 0 ? void 0 : regBundle.firstName) || '');
        setLastName((regBundle === null || regBundle === void 0 ? void 0 : regBundle.lastName) || '');
    }, []);
    var _React$useState4 = react_1.default.useState(false), formValid = _React$useState4[0], setFormValid = _React$useState4[1];
    react_1.default.useEffect(function () {
        setRegBundle({
            email: email,
            firstName: firstName,
            lastName: lastName
        });
        setFormValid(firstName.length > 2 && lastName.length > 2 && /\S+@\S+\.\S+/.test(email));
    }, [email, firstName, lastName]);
    var _React$useState5 = react_1.default.useState(true), userAcceptedTerms = _React$useState5[0], setUserAcceptedTerms = _React$useState5[1];
    var toggleUserAcceptedTerms = function toggleUserAcceptedTerms() {
        return setUserAcceptedTerms(!userAcceptedTerms);
    };
    var _React$useState6 = react_1.default.useState(false), processing = _React$useState6[0], setProcessing = _React$useState6[1];
    var register = function register() {
        setProcessing(true);
        _api_1.default('register', {
            email: email,
            firstName: firstName,
            lastName: lastName,
            tier: tier
        }).then(function (response) {
            if (!response)
                return;
            switch (response.status) {
                case 201:
                    {
                        // account created; fetch login email
                        _api_1.default('login', {
                            email: email
                        }).then(function () {
                            setPanel('checkEmail');
                            setProcessing(false);
                        });
                        break;
                    }
                default:
                    {
                        response && response.json().then(function (responseObject) {
                            var _responseObject$messa;
                            if (typeof responseObject.message === 'string')
                                responseObject.message = [responseObject.message];
                            (_responseObject$messa = responseObject.message) === null || _responseObject$messa === void 0 ? void 0 : _responseObject$messa.map(function (message) {
                                return setNotification({
                                    type: 'warning',
                                    title: 'Error',
                                    message: message
                                });
                            });
                            setProcessing(false);
                        });
                    }
            }
        }).catch(function (e) {
            console.log('TODO: convert to notification:', e);
            setNotification({
                type: 'warning',
                title: 'Error',
                message: 'Unknown error.'
            });
            setProcessing(false);
        });
    };
    return /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.BackButton, {
        onClick: function onClick() {
            return setPanel('pricing');
        }
    }, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Arrow, null)), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, {
        shortPadding: true
    }, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Header, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.EyebrowLabel, {
        alignment: "left",
        isDrawer: true
    }, "Create Account"), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Headline, null, "Enter your details to create a PRIOR account.")), /*#__PURE__*/ react_1.default.createElement(atoms_1.InputCheckbox, {
        name: "privacyPolicy",
        onChange: toggleUserAcceptedTerms,
        checked: userAcceptedTerms,
        outline: true
    }, "I agree to PRIOR\u2019s ", /*#__PURE__*/ react_1.default.createElement(StyledLink, {
        to: "/terms-of-use"
    }, "terms of use"), " and ", /*#__PURE__*/ react_1.default.createElement(StyledLink, {
        to: "/privacy-policy",
        target: "_blank"
    }, "privacy policy"), ".")), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, null, /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, {
        split: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        value: firstName,
        label: "First Name",
        name: "firstName",
        onChange: function onChange(_ref) {
            var value = _ref.target.value;
            return setFirstName(value);
        },
        required: true,
        disabled: processing,
        autoComplete: "off"
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        value: lastName,
        label: "Last Name",
        name: "lastName",
        onChange: function onChange(_ref2) {
            var value = _ref2.target.value;
            return setLastName(value);
        },
        required: true,
        disabled: processing,
        autoComplete: "off"
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "email",
        value: email,
        label: "Email Address",
        name: "email",
        onChange: function onChange(_ref3) {
            var value = _ref3.target.value;
            return setEmail(value);
        },
        required: true,
        disabled: processing,
        autoComplete: "off"
    })), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.ButtonWrapper, {
        shortPadding: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, Object.assign({
        shadow: true,
        size: "large",
        display: "flex",
        disabled: processing || !userAcceptedTerms || !formValid,
        onClick: function onClick() {
            return register();
        }
    }, {
        processing: processing
    }), "Join PRIOR"))));
}; // Styling
var StyledLink = styled_components_1.default(gatsby_1.Link).withConfig({
    displayName: "AccountRegisterForm__StyledLink",
    componentId: "mfmm7n-0"
})(["color:", " !important;"], _theme_1.palette.brown);
exports.default = AccountRegisterForm;
